import React, {Fragment} from 'react';
import ReactMarkdown from 'react-markdown';
import {ORDEREDLIST} from "../../../../components/sectionTypes";

export default function ListSection({type, prepend, append, elements}) {

    const array = [];
    for (const key in elements) {
        array.push(elements[key]);
    }

    array.sort((a, b) => a.position - b.position);

    const listItems = array.map((element) =>
        <li key={element.key} className="my-2">
            {element.content}
        </li>
    );

    const padding = "pl-6";

    const list = (ORDEREDLIST === type) ? <ol className={padding}>{listItems}</ol> : <ul className={padding}>{listItems}</ul>;

    return (
        <Fragment>
            <ReactMarkdown className={"text-justify mt-5 mb-2"} source={prepend}/>
            {list}
            <ReactMarkdown className={"text-justify mt-2 mb-2"} source={append}/>
        </Fragment>
    );

}


// WEBPACK FOOTER //
// ./src/visitors/components/post/sections/ListSection.js